module.exports = __webpack_public_path__ + "static/img/wear_detect1.568164f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/air_se_2021/wear_detect1.gif
// module id = ACM9
// module chunks = 1